"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationResourceType = exports.LocationRoomType = exports.LocationPlaceType = void 0;
var LocationPlaceType;
(function (LocationPlaceType) {
    LocationPlaceType["VID_CONFERENCE"] = "VID_CONFERENCE";
    LocationPlaceType["PHONE_INBOUND"] = "PHONE_INBOUND";
    LocationPlaceType["PHONE"] = "PHONE";
    LocationPlaceType["OUR_LOCATION"] = "OUR_LOCATION";
    LocationPlaceType["IN_HOUSE"] = "IN_HOUSE";
    LocationPlaceType["IN_PERSON"] = "IN_PERSON";
    LocationPlaceType["VIRTUAL_EVENT"] = "VIRTUAL_EVENT";
    LocationPlaceType["LOCATION"] = "LOCATION";
    LocationPlaceType["OFFICE"] = "OFFICE";
    LocationPlaceType["GOOGLE_LOCATION"] = "GOOGLE_LOCATION";
})(LocationPlaceType = exports.LocationPlaceType || (exports.LocationPlaceType = {}));
var LocationRoomType;
(function (LocationRoomType) {
    LocationRoomType["RESOURCE"] = "RESOURCE";
    LocationRoomType["RECORD_TYPE"] = "RECORDTYPE";
})(LocationRoomType = exports.LocationRoomType || (exports.LocationRoomType = {}));
var LocationResourceType;
(function (LocationResourceType) {
    LocationResourceType["RESOURCE"] = "RESOURCE";
})(LocationResourceType = exports.LocationResourceType || (exports.LocationResourceType = {}));
